// extracted by mini-css-extract-plugin
export default {"collapsibleContent":"CollapsibleSection_collapsibleContent__UCrJO","collapsibleContentOpen":"CollapsibleSection_collapsibleContentOpen__kRg3-"};